import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=31fda710&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fda710')) {
      api.createRecord('31fda710', component.options)
    } else {
      api.reload('31fda710', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=31fda710&", function () {
      api.rerender('31fda710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/Slider.vue"
export default component.exports